<script>
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: 'OutageLateChart',
  components: {Pie},
  props: {
    client_id: Number,
    organisation_id: Number
  },
  async mounted() {
    await this.getOutageLate(this.client_id, this.organisation_id);
  },
  data() {
    return {
      outage_late_loading: true,
      outage_late_data: {},
      chartData: {
        labels: [
          'Storingen te laat',
          'storingen nog 2 dagen te gaan',
          'Storingen optijd'
        ],
        datasets: [
          {
            label: 'Percentage',
            backgroundColor: ['#942320', '#c6a900', '#228e62'],
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right',
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const value = context.parsed;

                // Use your total from data
                const total = this.outage_late_data.outages_open_total || 1;
                const percent = ((value / total) * 100).toFixed(1);

                return ` ${value} (${percent}%)`;
              }
            }
          }
        }
      }
    }
  },
  watch: {
    client_id: {
      handler(newVal) {
        this.getOutageLate(newVal, this.organisation_id);
      }
    },
    organisation_id: {
      handler(newVal) {
        this.getOutageLate(this.client_id, newVal);
      }
    }
  },
  methods: {
    async getOutageLate(client_id, organisation_id) {
      this.outage_late_loading = true;
      try {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/dashboard/' + client_id + '/outage-late/' + organisation_id, {
          credentials: 'include'
        });

        this.outage_late_data = await response.json();
      } catch (error) {
        console.error('Error:', error);
      }
      this.fillChartData();
      this.outage_late_loading = false;
    },
    fillChartData() {
      this.chartData.datasets[0].data = [
        this.outage_late_data.outages_late,
        this.outage_late_data.outages_2_days_left,
        this.outage_late_data.outages_in_time
      ];
    }
  }
}
</script>

<template>
  <Pie v-if="!outage_late_loading"
       id="outages-late-chart"
       :options="chartOptions"
       :data="chartData"
  />
</template>

<style scoped lang="scss">

</style>
